<template>
  <div id="buyer">
    <div class="list">
      <div class="tabbar">
        <div id="tabbar">
          <div class="tabbarItem" :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index"
               @click="clickItem(item,index)">
            {{ item }}
          </div>
        </div>
        <div class="filter_search">
          <input type="text" class="filter_search_input" v-model="match" placeholder="请输入账户关键词">
          <span class="filter_search_btn" @click="clickMatch">确认</span>
        </div>
      </div>
      <div class="filter">
        <div class="select_ground">
          <div class="select_data">
            <el-select v-model="value" :popper-append-to-body="false" placeholder="选择时间" @change="selectTimeChange">
              <el-option
                v-for="(item,index) in options"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select_game">
            <el-select v-model="selectGameValue" clearable :popper-append-to-body="false" placeholder="选择游戏"
                       @change="selectGameChange">
              <el-option
                v-for="(item,index) in selectGame"
                :key="index"
                :label="item.label"
                :value="{value:item.value,label:item.label}">
              </el-option>
            </el-select>
          </div>
          <div class="select_Pstatus">
            <el-select v-model="selectPStatusValue" clearable :popper-append-to-body="false" placeholder="选择商品状态"
                       @change="selectPStatusChange">
              <el-option
                v-for="(item,index) in selectPStatus"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select_status">
            <el-select v-model="selectStatusValue" clearable :popper-append-to-body="false" placeholder="降价请求状态"
                       @change="selectStatusChange">
              <el-option
                v-for="(item,index) in selectStatus"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="product_list">
        <div v-if="listLoading" class="list_loading" v-loading="listLoading"></div>
        <div v-else-if="totalCount !== 0">
          <div class="delect" :style="!allcheckedShow?'justify-content:flex-end':'justify-content:space-between'">
            <el-checkbox v-model="allchecked" v-if="allcheckedShow" @change="checkboxChange">全选</el-checkbox>
            <div class="delBtn" v-if="!allcheckedShow" @click="allcheckedShow = true">
              <i class="el-icon-delete"></i>批量删除
            </div>
            <div class="delBtn" v-else>
              <span @click="delData">删除</span>
              <span @click="allcheckedShow = false">取消</span>
            </div>
          </div>
          <bargainItem :list="tableData" :selectItemIndex="selectItemIndex" :allchecked-show="allcheckedShow" :selectItem="selectItem" :api-bargain="apiBargain" @refreshData="clickMatch()"
                       type="buyer"></bargainItem>
          <div class="pages">
            <common-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="PageSize"
              layout="prev, pager, next, jumper"
              :total="totalCount">
            </common-pagination>
          </div>
        </div>
        <div class="no_data" v-else>
          <empty-state
            title="暂无降价请求"
            description="可以调整筛选条件后再次查看"
            icon="el-icon-price-tag"
            :icon-size="52">
          </empty-state>
        </div>
      </div>
    </div>
    <!--  还价确认框  -->
    <el-dialog
      :visible.sync="refuseDialog"
      custom-class="refuseDialog"
      :show-close="false"
      width="446px"
      top="35vh"
      center>
      <div id="refuseDialog">
        <div class="originalPrice">商品原价：{{ refuseData.price }}</div>
        <div class="offerAPrice">
          <i class="iconfont icon-price"></i>
          我的出价：{{ refuseData.bargain_price }}
        </div>
        <div class="counteroffer">
          修改出价：
          <el-input
            type="number"
            placeholder="输入修改后的价格"
            v-model="counterofferInput"
            class="counterofferInput">
          </el-input>
        </div>
        <div class="tip">（提示：24小时内只能求降价1次）</div>
        <div class="btnGroup">
          <div class="btn" @click="change_price">确认修改</div>
        </div>
        <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="refuseDialog = false">
      </div>
    </el-dialog>
    <my-dialog
      title="提示"
      width="446"
      custom-class="buyerBargainChangeDialog"
      box-padding="30px 42px 34px"
      :show="barginChangeShow"
      text="当前商品已开启新求降价，建议您重新出价！"
      :closeFun="() =>barginChangeShow = false">
      <div slot="btn" class="bargainChangeBtnGroup">
        <el-button class="wait" @click="barginChangeShow = false">继续等待</el-button>
        <el-button class="reBargin" @click="reBargin">重新出价</el-button>
      </div>
    </my-dialog>
  </div>
</template>
<script>
import {
  apiGameList,
  apiBuyBargainList,
  apiBuyBargainListEquip,
  apiBargainAdd,
  apiBargainAddEquip,
  apiBuyBargainStatus,
  apiBargainBuyDel,
  delOldBargin
} from "@/request/API";
import bargainItem from "@/views/PersonalCenter/components/bargainItem";
import myDialog from '@/components/myDialog'
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  props: {},
  components: {
    bargainItem,
    myDialog,
    CommonPagination,
    EmptyState
  },
  data() {
    return {
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // 默认每页显示的条数（可修改）
      PageSize: 10,
      // tabbar 选中项
      selectItem: '游戏账号',
      // tabbar 选中项Index
      selectItemIndex: 0,
      tabbarItem: [
        '游戏账号', '装备道具',
      ],
      //表格数据
      tableData: [],
      //列表加载状态
      listLoading: true,
      //选择时间下拉框
      options: [
        {value: '0', label: '全部'},
        {value: '1', label: '本周内'},
        {value: '2', label: '当月'},
        {value: '3', label: '三个月内'},
        {value: '4', label: '半年内'},
        {value: '5', label: '半年以上'},
        {value: '6', label: '一年内'},
      ],
      value: '',
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: '',
      //选择商品状态下拉框
      selectPStatus: [
        {value: '1', label: '在售'},
        {value: '2', label: '已售'},
        {value: '3', label: '已下架'},
        {value: '6', label: '交易中'},
      ],
      selectPStatusValue: '',
      //选择请求状态下拉框
      selectStatus: [
        {value: '1', label: '卖家确认中'},
        {value: '2', label: '卖家同意'},
        {value: '3', label: '求降价失败'},
      ],
      selectStatusValue: '',
      //关键词搜索
      match: '',
      //当前页码
      page: 1,
      apiBargain: apiBargainAdd,
      //批量删除
      allchecked: false,
      allcheckedShow: false,
      //修改价格弹窗
      refuseDialog: false,
      refuseData: {},
      counterofferInput: '',
      barginChangeShow:false
    }
  },
  methods: {
    reBargin() {
      delOldBargin({
          game_id:this.refuseData.game_id,
          product_id:this.refuseData.product_id
        }).then(res=>{
          let body = document.getElementsByTagName("body");
           body[0].style.removeProperty("overflow");
          this.$router.push({
              path: "/gamedetails",
              query: {
                game_id: this.refuseData.game_id,
                id: this.refuseData.product_id,
              },
            });
      })
    },
    // item切换
    clickItem(item, index) {
      //获取游戏列表
      apiGameList({}).then(res => {
        res.data.forEach((item, index) => {
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      this.selectItem = item
      this.selectItemIndex = index
      this.selectPStatusValue = ''
      if (this.selectItem == '游戏账号') {
        this.apiBargain = apiBargainAdd
        this.selectPStatus = [
          {value: '1', label: '在售'},
          {value: '2', label: '已售'},
          {value: '3', label: '已下架'},
          {value: '6', label: '交易中'},
        ]
        this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
      } else {
        this.apiBargain = apiBargainAddEquip
        this.selectPStatus = [
          {value: '2', label: '在售'},
          {value: '3', label: '已下架'},
        ]
        this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
      }
    },
    handleCurrentChange(val) {
      if (this.selectItem == '游戏账号') {
        this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, val)
      } else {
        this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, val)
      }
    },
    //表格 row 单击事件
    tablaRowClick(row, column, event) {
      switch (this.selectItem) {
        case "游戏账号":
          this.$router.push({
            name: 'GameDetails',
            query: {
              game_id: row.game_id,
              id: row.product_id,
              source_page: this.$route.path.slice(1)
            }
          });
          break;
        case "装备道具":
          this.$router.push({
            name: 'EquipmentDetails',
            query: {
              game_id: row.game_id,
              id: row.product_id
            }
          });
          break;
      }

    },
    //选择时间 下拉框 监听
    selectTimeChange() {
      if (this.selectItem == '游戏账号') {
        this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
      } else {
        this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
      }
    },
    //游戏筛选 下拉框监听事件
    selectStatusChange(event) {
      this.page = 1
      if (this.selectItem == '游戏账号') {
        this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
      } else {
        this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
      }
    },
    //游戏筛选 下拉框监听事件
    selectPStatusChange(event) {
      this.page = 1
      if (this.selectItem == '游戏账号') {
        this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
      } else {
        this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
      }
    },
    //选择游戏 下拉框 监听
    selectGameChange(event) {
      if (this.selectItem == '游戏账号') {
        this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
      } else {
        this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
      }
    },
    //关键词搜索
    clickMatch() {
      if (this.selectItem == '游戏账号') {
        this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
      } else {
        this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
      }
    },
    /**
     * 游戏账号 降价请求列表
     * @param type    时间下拉框
     * @param game_id 游戏下拉框
     * @param match   关键字
     * @param page    当前页码
     */
    getaBuyBargainList(type, game_id, match, page) {
      this.allchecked = false
      this.allcheckedShow = false
      this.listLoading = true
      apiBuyBargainList({
        type: type,
        game_id: game_id,
        match: match,
        page: page,
        goodsStatus: this.selectPStatusValue,
        status: this.selectStatusValue,
      }).then(res => {
        this.tableData = res.data.list

        this.totalCount = res.data.total
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], "checkbox", false);
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    /**
     * 装备道具 降价请求列表
     * @param type    时间下拉框
     * @param game_id 游戏下拉框
     * @param match   关键字
     * @param page    当前页码
     */
    getaBuyBargainListEquip(type, game_id, match, page) {
      this.allchecked = false
      this.allcheckedShow = false
      this.listLoading = true
      apiBuyBargainListEquip({
        type: type,
        game_id: game_id,
        match: match,
        page: page,
        goodsStatus: this.selectPStatusValue,
        status: this.selectStatusValue,
      }).then(res => {
        this.tableData = res.data.list
        this.totalCount = res.data.total
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], "checkbox", false);
        })
      }).finally(() => {
        this.listLoading = false
      })
    },

    //改价确认
    change_price_confirm(data) {
      this.refuseDialog = true
      this.refuseData = data
      this.counterofferInput = ''
    },
    async change_price() {
      if((this.counterofferInput+'').includes('.')) {
        this.$message({
          type: "error",
          message: '价格不支持小数',
          center: true
        })
        return
      }
      await this.apiBargain({
        id: this.refuseData.id,
        price: this.counterofferInput
      }).then(res => {
        this.$message({
          message: "修改成功",
          center: true,
          type: 'success'
        })
        if (this.selectItem == '游戏账号') {
          this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
        } else {
          this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
        }
      }).catch(err => {
        if(err?.code === 10019) {
          this.barginChangeShow = true
          let body = document.getElementsByTagName("body");
          body[0].style.overflow = "hidden";
        } else {
          this.$message({
            message: err.msg,
            center: true,
            type: 'error'
          })
        }
      })
      this.refuseDialog = false
    },
    //初始化数据
    onLoad() {
      //游戏列表  下拉框
      apiGameList({}).then(res => {
        res.data.forEach((item, index) => {
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      // 已成交 账号列表
      this.listLoading = true
      apiBuyBargainList({}).then(res => {
        this.tableData = res.data.list
        this.totalCount = res.data.total
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], "checkbox", false);
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    /**
     * 全选框change事件
     * @param value
     */
    checkboxChange(value) {
      this.tableData.forEach((item, index) => {
        item.checkbox = value
      })
    },
    /**
     * 取消全选
     */
    allCheckedCancel() {
      this.allchecked = false
    },
    /**
     * 删除数据
     */
    delData() {
      let ids = []
      this.tableData.forEach(item => {
        if (item.checkbox) {
          ids.push(item.id)
        }
      })
      if (ids.length === 0) {
        this.$message({
          type: 'error',
          center: true,
          message: '您还未选中任何商品～'
        })
      }else{
        apiBargainBuyDel({
          ids: ids
        }).then(res => {
          this.$message({
            type: 'success',
            center: true,
            message: "删除成功"
          });
          if (this.selectItem == '游戏账号') {
            this.getaBuyBargainList(this.value, this.selectGameValue.value, this.match, this.page)
          } else {
            this.getaBuyBargainListEquip(this.value, this.selectGameValue.value, this.match, this.page)
          }
        })
      }
    }
  },
  mounted() {
    //初始化数据
    this.onLoad()
  },
  watch: {},
  computed: {}
}
</script>

<style lang='less'>
.refuseDialog {
  overflow: visible;
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  #refuseDialog {
    position: relative;
    padding: 30px 42px 34px;
    display: flex;
    flex-direction: column;

    .originalPrice {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #111827);
      margin: 0 0 10px;
    }

    .offerAPrice {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--primary, #FF7A1A);
      display: flex;
      align-items: center;
      margin: 0 0 22px;

      i {
        margin: 0 6px 0 0;
      }
    }

    .counteroffer {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #111827);
      display: flex;
      align-items: center;
      margin: 0 0 10px;

      .counterofferInput {
        width: 250px;

        .el-input__inner {
          height: 40px;
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
        }

        .el-input__inner:focus {
          border-color: var(--primary, #FF5A1F);
          box-shadow: none;
        }
      }
    }

    .tip {
      margin: 0 0 22px 80px;
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      text-align: left;
      color: var(--text-muted, #9AA0AC);
    }

    .btnGroup {
      display: flex;
      justify-content: center;

      .btn {
        width: 290px;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: CENTER;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        cursor: pointer;
        box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
      }

      .btn:hover {
        background: var(--primary-hover, #E84A12);
        box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
      }

    }

    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }

}
</style>

<style lang='less' scoped>
/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/ .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
  -moz-appearance: textfield;
}

#buyer {
  padding: 0;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .list {
    min-height: 620px;
    padding: 20px;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    #tabbar {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .tabbarItem {
      position: relative;
      min-width: 86px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    .tabbarItem:hover {
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve,
    .isAcitve:hover {
      padding-bottom: 0;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
    }

    .isAcitve::after,
    .isAcitve:hover::after {
      content: '';
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 5px;
      height: 3px;
      border-radius: 2px;
      background: var(--primary, #FF5A1F);
    }

    .filter_search {
      width: 318px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input {
        width: 100%;
        min-width: 0;
        height: 38px;
        padding: 0 16px;
        background: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: var(--text-main, #111827);
      }

      .filter_search_input::-webkit-input-placeholder {
        font-size: 14px;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn {
        width: 92px;
        height: 32px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        box-shadow: 0 6px 14px rgba(255, 90, 31, 0.18);
        transition: box-shadow .2s ease, background .2s ease;
      }

      .filter_search_btn:hover {
        background: var(--primary-hover, #E84A12);
        box-shadow: 0 8px 18px rgba(255, 90, 31, 0.22);
      }
    }
  }

  .filter {
    min-height: 40px;
    height: auto;
    margin: 18px 0;
    padding: 0;
    display: flex;
    align-items: center;
    background: transparent;
    border: none;

    .select_ground {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;

      .select_data,
      .select_game,
      .select_status,
      .select_Pstatus {
        margin-right: 0;
      }

      /deep/.el-input__inner {
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/.el-input.is-focus .el-input__inner,
      /deep/.el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/.popper__arrow {
        left: 155px !important;
      }

      /deep/.el-select-dropdown {
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/.el-select-dropdown__item {
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/.el-select-dropdown__item.hover,
      /deep/.el-select-dropdown__item:hover {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/.el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }
    }
  }

  .product_list {
    min-height: 300px;
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
  }

  .delect {
    min-height: 54px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    background: var(--bg-tag, #F0EDE8);
    border-bottom: 1px solid var(--border-soft, #E8E4DE);

    .delBtn {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 600;
      line-height: 20px;
      color: var(--text-secondary, #5A5F6B);
      cursor: pointer;
      transition: color .2s ease;

      &:hover {
        color: var(--text-main, #1A1D24);
      }

      i {
        margin: 0 2px 0 0;
        color: inherit;
        font-size: 15px;
        font-weight: 600;
        line-height: 1;
      }

      span {
        height: 30px;
        padding: 0 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        background: var(--danger, #EF4444);
        cursor: pointer;
      }

      span:last-of-type {
        color: var(--text-secondary, #5A5F6B);
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
      }
    }
  }

  /deep/.el-checkbox {
    display: flex;
    align-items: center;
  }

  /deep/.el-checkbox__label {
    font-size: 14px;
    color: var(--text-secondary, #5A5F6B);
  }

  /deep/.el-checkbox__inner {
    border-radius: 4px;
    border-color: var(--border-strong, #CBD5E1);
  }

  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: var(--primary, #FF5A1F);
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary, #FF5A1F);
    border-color: var(--primary, #FF5A1F);
  }

  /deep/.el-checkbox__input.is-focus .el-checkbox__inner,
  /deep/.el-checkbox__inner:hover {
    border-color: var(--primary, #FF5A1F);
  }

  .pages {
    min-height: 88px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-card, #FFFFFF);
  }

  .list_loading,
  .no_data {
    min-height: 300px;
    padding: 64px 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.bargainList {
    .bargainItem {
      height: 206px;
      padding: 0 0 0 18px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      transition: background .2s ease;

      .img {
        margin-right: 18px;

        div {
          width: 164px;
          height: 164px;
          overflow: hidden;
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
        }
      }

      .baseInfo {
        width: 392px;
        height: 164px;
        padding-right: 20px;
        border-right: 1px solid var(--border-soft, #E8E4DE);

        .number,
        .zone,
        .other,
        .time {
          font-size: 13px;
          color: var(--text-muted, #9AA0AC);
        }

        .name {
          font-size: 15px;
          font-weight: 500;
          color: var(--text-main, #111827);
          line-height: 24px;

          .status {
            display: inline-flex;
            align-items: center;
            height: 22px;
            padding: 0 8px;
            border-radius: 4px;
            background: var(--bg-tag, #F0EDE8);
            color: var(--text-main, #1A1D24);
            font-size: 12px;
          }
        }

        .price {
          .originalPrice {
            color: var(--text-secondary, #5A5F6B);

            div {
              color: var(--text-main, #111827);
              font-size: 18px;
            }
          }

          .quotedPrice {
            color: var(--primary, #FF7A1A);

            div {
              color: var(--primary, #FF7A1A);
              font-size: 20px;
            }
          }
        }
      }

      .operating {
        width: 272px;

        .status {
          color: var(--text-main, #111827);
          font-size: 15px;
        }

        .time {
          color: var(--text-muted, #9AA0AC);
          font-size: 13px;
        }

        .btnGroup {
          width: 100%;
        }

        .btnGroup > div {
          width: 100%;
          display: flex;
          justify-content: center;
          gap: 6px;
          flex-wrap: wrap;

          .btn {
            height: 30px;
            min-width: 82px;
            padding: 0 12px;
            margin: 18px 0 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            line-height: 1;
            white-space: nowrap;
            background: var(--primary, #FF5A1F);
            border: 1px solid transparent;
            border-radius: 3px;
            color: #FFFFFF;
            font-size: 13px;
            transition: box-shadow .2s ease, opacity .2s ease, background .2s ease, color .2s ease, border-color .2s ease;
          }

          .btn:hover {
            background: var(--primary-hover, #E84A12);
            box-shadow: 0 8px 18px rgba(255, 90, 31, 0.20);
          }

          .modify {
            background: var(--bg-card, #FFFFFF);
            border-color: var(--bg-dark, #1A1D24);
            color: var(--text-main, #1A1D24);
          }

          .modify:hover {
            background: var(--bg-tag, #F0EDE8);
            box-shadow: none;
          }

          .other {
            border-color: transparent;
            background: var(--primary, #FF5A1F);
            color: #FFFFFF;
          }

          .cusSer {
            min-width: 104px;
          }

          .btn_size {
            min-width: 82px;
          }
        }
      }
    }

    .bargainItem:hover {
      background: var(--bg-tag, #F0EDE8);
    }
  }

  /deep/.el-dialog {
    border-radius: 4px;
  }
}

/deep/.buyerBargainChangeDialog {
  overflow: visible;
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  #tipDialog {
    align-items: stretch;
  }

  .title {
    margin: 0 0 12px !important;
    font-size: 16px !important;
    line-height: 24px !important;
    font-family: PingFang SC, PingFang SC-Medium !important;
    font-weight: 500 !important;
    color: var(--text-main, #111827) !important;
  }

  .text {
    max-width: none !important;
    margin: 0 0 24px !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: var(--text-secondary, #5A5F6B) !important;
  }

  .close {
    bottom: -40px !important;
  }
}

.bargainChangeBtnGroup {
  display: flex;
  justify-content: center;
  gap: 15px;

  .wait,
  .reBargin {
    width: 138px;
    height: 38px;
    margin: 0;
    padding: 0;
    border-radius: 3px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-size: 14px;
    font-weight: 500;
    transition: box-shadow .2s ease, opacity .2s ease, background .2s ease, color .2s ease, border-color .2s ease;

    /deep/span {
      line-height: 38px;
    }
  }

  .wait {
    color: var(--text-main, #1A1D24);
    background: #FFFFFF;
    border: 1.5px solid var(--bg-dark, #1A1D24);
  }

  .wait:hover {
    color: var(--text-main, #1A1D24);
    border-color: var(--bg-dark, #1A1D24);
    background: var(--bg-tag, #F0EDE8);
  }

  .reBargin {
    border: none;
    color: #FFFFFF;
    background: var(--primary, #FF5A1F);
  }

  .reBargin:hover {
    color: #FFFFFF;
    background: var(--primary-hover, #E84A12);
    box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);
  }
}
</style>
